import { RouteRecordRaw } from 'vue-router'

import {
  brelagSupporterRouteName,
  VIEW_ID,
} from '@/apps/brelag/brelag-supporter/app'
import MainMenu from '@/apps/brelag/brelag-supporter/components/MainMenu.vue'
import KnockautXProgrammers from '@/apps/brelag/brelag-supporter/knockautx-programmers/KnockautXProgrammers.vue'
import SupporterKnockautDashboard from '@/apps/brelag/brelag-supporter/views/SupporterKnockautDashboard.vue'
import { clientAppRegistryGet } from '@/apps/clientAppRegistry'
import RouterPassThrough from '@/components/common/RouterPassThrough.vue'

const route: RouteRecordRaw = {
  path: clientAppRegistryGet(VIEW_ID, 'path'),
  name: VIEW_ID,
  redirect: { name: brelagSupporterRouteName('mandator-root') },
  components: {
    default: RouterPassThrough,
    'main-menu': MainMenu,
  },
  children: [
    {
      path: 'mandator',
      name: brelagSupporterRouteName('mandator-root'),
      redirect: { name: brelagSupporterRouteName('mandator-list') },
      component: RouterPassThrough,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: 'list',
          name: brelagSupporterRouteName('mandator-list'),
          props: true,
          component: () =>
            import('../brelag-supporter/components/MandatorList.vue'),
          meta: {
            requiresList: {
              organisation: true,
            },
          },
        },
        {
          path: 'create',
          name: brelagSupporterRouteName('organisation-create'),
          component: () =>
            import('../brelag-admin/components/mandator/MandatorForm.vue'),
          props: { id: '0' },
        },
        {
          path: ':id',
          name: brelagSupporterRouteName('organisation-detail'),
          props: true,
          component: () =>
            import('../brelag-admin/components/mandator/MandatorForm.vue'),
        },
      ],
    },
    {
      path: 'project',
      name: brelagSupporterRouteName('project-list'),
      component: () =>
        import('../brelag-supporter/components/SupporterProjectList.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: 'legacy-project-import',
      name: brelagSupporterRouteName('legacy-project-import'),
      component: () =>
        import(
          '../brelag-admin/components/project-import/LegacyProjectImport.vue'
        ),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: 'knockaut-license-key',
      name: brelagSupporterRouteName('knockaut-license-key-root'),
      redirect: { name: brelagSupporterRouteName('knockaut-license-key-list') },
      component: RouterPassThrough,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: brelagSupporterRouteName('knockaut-license-key-list'),
          props: true,
          component: () =>
            import('../brelag-supporter/components/KnockautLicenseKeyList.vue'),
        },
      ],
    },
    {
      path: 'knockaut-dashboard',
      name: brelagSupporterRouteName('knockaut-dashboard'),
      component: SupporterKnockautDashboard,
      meta: {
        requiresAuth: true,
      },
      children: [],
    },
    {
      path: 'knockautx-programmers',
      name: brelagSupporterRouteName('knockautx-programmers'),
      component: KnockautXProgrammers,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: 'siegenia',
          name: brelagSupporterRouteName('siegenia-programmer'),
          props: true,
          component: () =>
            import(
              /* webpackChunkName: "supporter-mandator-list" */ '../brelag-supporter/knockautx-programmers/siegenia/Siegenia.vue'
            ),
        },
      ],
    },
  ],
}

export default route
